import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../shared/Button";
import { useTranslation, Trans } from "react-i18next";
import { colors } from "../../theme";
import { Grid } from "@material-ui/core";
import clsx from "clsx";
import { useMenu } from "./MenuContext";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    textAlign: "center",
  },
  button: {
    width: "123px",
    margin: "10px;",
  },
  signUpButton: {},
  signInButton: {
    backgroundColor: colors.SIGN_IN_BUTTON_BG,
    color: colors.SIGN_IN_BUTTON_TEXT,
    "&:hover": {
      backgroundColor: colors.SIGN_IN_BUTTON_BG,
    },
  },
  sloganContainer: {
    textAlign: "center",
    paddingBottom: "8px",
  },
  slogan: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.33",
    letterSpacing: "normal",
    textAlign: "center",
    color: colors.SLOGAN_TEXT,
  },
}));

export default function UnauthenticatedMenu() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { closeMenu } = useMenu();

  return (
    <Grid container item direction="column">
      <Grid item className={classes.sloganContainer}>
        <Trans>
          <span className={classes.slogan}>{t("app.slogan")}</span>
        </Trans>
      </Grid>
      <Grid item className={classes.buttonContainer}>
        <Button
          linkTo="/signup"
          className={clsx(classes.signUpButton, classes.button)}
          onClick={closeMenu}
        >
          {t("header.signup")}
        </Button>
        <Button
          linkTo="/signin"
          className={clsx(classes.signInButton, classes.button)}
          onClick={closeMenu}
        >
          {t("header.signin")}
        </Button>
      </Grid>
    </Grid>
  );
}
